import { OrganizationKeyName } from "../../../../model/Organization";
import { GetUserVoucherSuccessResponse } from "../../model/GetUserVoucherSuccessResponse";

export const GET_USER_VOUCHER_SUCCESS = "SHOP:GET_USER_VOUCHER_SUCCESS";

export const getUserVoucherSuccessAction = (
  organization: OrganizationKeyName,
  id: string,
  data: GetUserVoucherSuccessResponse
) => ({
  type: GET_USER_VOUCHER_SUCCESS as typeof GET_USER_VOUCHER_SUCCESS,
  organization,
  id,
  data,
});

export type GetUserVoucherSuccessAction = ReturnType<
  typeof getUserVoucherSuccessAction
>;
